import { Link } from 'react-router-dom';

function BiographyContent() {
  return (
    <div className="content-body biography-content">
      <p><b>John Malam is a best-selling children's non-fiction author from Cheshire county, north-west England.</b></p>

      <p>John has been writing children's information books since the late-1980s, and has written more than 250 different titles, many of which have been widely translated.</p>

      <p>Usually heavily illustrated with photographs and illustrations, John's books are mainly created for school and public libraries, where they are used as educational resources for the school curriculum.</p>

      <p>With a degree in Ancient History and Archaeology from the University of Birmingham, and practical experience as a field archaeologist, it's not surprising that many of John's books focus on history (<Link to="/books">more about John's books here</Link>).</p>

      <p>Before becoming an author, John was an in-house editor for UK scientific, technical and medical publishers, until moving to a mass-market children's publisher, where he worked with leading authors, illustrators, brands and licensed characters.</p>



      <div className="biography-award-layout">
        <div>
        <p>In addition to writing for children, John is an experienced and popular visitor to schools, both in the UK and overseas. He's visited more than 500 schools the length and breadth of the UK, and has made visits to schools in Guernsey, and also international schools in Germany, Romania, China, and Brunei.</p>

        <p>John is a National Literacy Trust Reading Champion, recognised for his work in encouraging children, particularly boys, to engage with books.</p>

        <p>Away from writing, John is an active member of his local community, and in 2019 was recognised for his voluntary services to the community when he became an Honorary Freeman of Cheshire West & Chester Council, the highest award bestowed by the borough on an individual (<a target="_blank" rel="noreferrer" href="https://www.northwichguardian.co.uk/news/17974815.author-set-become-first-honorary-freeman-winsford/">more about that here</a>).</p>
        </div>

        <aside className="biography-award-box" aria-label="John's Honorary Freeman award">
          <figure className="biography-award-figure">
            <img
              src={`${process.env.PUBLIC_URL}/gallery/john-honorary-freeman-award.jpg`}
              alt="John Malam Honorary Freeman award"
            />
            <figcaption>John's Honorary Freeman award</figcaption>
          </figure>
        </aside>
      </div>

      <p>And finally &hellip; a few words about John's family name. It's pronounced with a soft first vowel (say: may-lam not mal-am), and it's a palindrome, one of the very few English surnames which can be spelled the same forwards and backwards. For more about the Malam family tree, and the branch which John belongs to, see <Link to="/malamfamilyhistory">here</Link>.</p>

      <div className="biography-quote-list">
        <div className="content-quote-box">
          <p>"I was having so much fun, I didn't realise I was learning anything, but I was."</p>
          <p><i>&mdash; Comment from a Y6 boy (age 10)</i></p>
        </div>

        <div className="content-quote-box">
          <p>"You are the best visiting author we have ever had. It's like you are chocolate up against fruit."</p>
          <p><i>&mdash; Comment from a Y6 girl (age 10)</i></p>
        </div>
      </div>

      <iframe
        className="biography-school-map"
        title="John Malam school visits map"
        src="https://www.google.com/maps/d/embed?mid=z_FXTQDpp3Rg.kGAJhEvKe5Vk&z=6&amp;&ll=54.7893283,-3.2540641,6.11z"
        width="100%"
        height="700"
      />
    </div>
  );
}

export default BiographyContent;
